import { isMobile } from "react-device-detect";
export const getIsMobile = () => isMobile;
//# sourceMappingURL=deviceDetect.js.map